import Com from '../teaser_eu';
import css from './index.module.scss';
import CrowdFundingH5 from '@/componentsH5/CrowdFunding';
import { useGlobal } from '@/utils/useGlobal';
import { bundleData } from '@/data/crowdfunding/delta2max';
import { ACTIVITY_MAP } from '@/constants/delta2max';

export default function CrowdFunding({ productDetail, resProductCatagory, nowSysTime, supportData, crowdfundingTimeline }: any) {
    const { useRouter, useLang } = useGlobal();
    const { t } = useLang('delta2max');
    const { locale } = useRouter();
    const bundlesData = bundleData[locale] || bundleData.jp;
    const activityId = ACTIVITY_MAP[locale] || ACTIVITY_MAP.jp;
    const bannerData = {
        // 1.EFPic 2.Image
        swiperImgs: [
            // `/video/delta2max/crowdfunding/h5/banner0${locale === 'jp' ? '_jp' : ''}.mp4`,
            `/media/delta2max/crowdfunding/h5/banner1.jpg`,
            `/media/delta2max/crowdfunding/h5/banner2.jpg`,
            `/media/delta2max/crowdfunding/h5/banner3.jpg`,
            `/media/delta2max/crowdfunding/h5/banner4.jpg`,
            `/media/delta2max/crowdfunding/h5/banner5.jpg`,
        ],
        webpUrl: '',
        subTitle: '',
        title: t('crowdfunding.header.title'),
        desc: t.rich('crowdfunding.header.desc', {
            dot: (text: string) => <span className="dot">{text}</span>,
        }),
        showTC: ['jp'].includes(locale), // 是否显示问号 T&C内容弹窗
        productKey: 'delta2max',
        showCountdown: true,
    };

    const shopifyBtnProps = {
        /// domain & token
        options: (() => {
            const map: any = {
                // jp: {
                //     domain: 'ecoflow-japan.myshopify.com',
                //     storefrontAccessToken: '725fc1c85ba5b3e12e3933afe8c3f32a',
                // },
                // us: {
                //     domain: 'ecoflow-tech.myshopify.com',
                //     storefrontAccessToken: '53235765553831c6dfca54cac05e9d9e',
                // },
                // ca: {
                //     domain: 'ecoflow-canada.myshopify.com',
                //     storefrontAccessToken: '0e67d1cc51449b5d6b52925de84167a0',
                // },
            };
            return map[locale] || null;
        })(),
        // 购物车
        cartText: {
            title: t('crowdfunding.shopify_btn.title'),
            total: t('crowdfunding.shopify_btn.total'),
            empty: t('crowdfunding.shopify_btn.empty'),
            notice: t('crowdfunding.shopify_btn.notice'),
            button: t('crowdfunding.shopify_btn.button'),
        },
    };
    return (
        <div className={`d2x-crowdfunding ${css.d2xCrowdfunding}`}>
            <CrowdFundingH5
                productDetail={productDetail}
                resProductCatagory={resProductCatagory}
                nowSysTime={nowSysTime}
                crowdfundingTimeline={crowdfundingTimeline}
                shopifyBtnProps={shopifyBtnProps}
                bundlesData={bundlesData}
                supportData={supportData}
                bannerData={bannerData}
                activityId={activityId}
                Com={Com}
                needEmail={locale === 'jp'}
            />
            <style jsx global>
                {`
                    .product_naver {
                        display: none;
                    }
                `}
            </style>
        </div>
    );
}
